export default "__VITE_ASSET__a97247ff__"